define('shared/util/throttle',[],function(){
    'use strict';
    return function throttle(callback, delay) {
        var handle;
        return function(){
            if (handle) {
                return;
            }

            handle = setTimeout(function(){
                try{
                    callback();
                }
                catch(ex) {}
                handle = null;
            }, delay);
        };
    };
});
